export default __webpack_public_path__ + "static/media/logo.571b5f6c.svg";